import React from 'react';
import { styles } from '../config/styles';
import { ROLE_LABELS, ROLES_ELEGIBLES_SIN_ASIGNAR } from '../constants/roles';

/**
 * Transición hacia roles asignados: solo la ve quien todavía no tiene rol (ni
 * asignado por un admin ni de comercial en el SGC). Comercial ya no se elige.
 */
const RoleSelectionModal = ({ onRoleSelect, onSignOut, opciones = ROLES_ELEGIBLES_SIN_ASIGNAR }) => {
  const buttonBase = {
    ...styles.button,
    flex: '1 1 140px',
    minWidth: '140px',
    fontSize: '1rem',
    padding: '1rem',
  };

  return (
    <div style={styles.modalOverlay}>
      <div style={{...styles.modalContent, maxWidth: '560px', textAlign: 'center'}}>
        <div style={{...styles.logo, fontSize: '2rem', marginBottom: '1rem'}}>
            axon <span style={{ fontWeight: '300' }}>capital</span>
        </div>
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem', color: styles.colors.secondary }}>
          Elegí tu rol para esta sesión
        </h2>
        <p style={{color: styles.colors.secondary, opacity: 0.8, marginBottom: '2.5rem', lineHeight: 1.5}}>
          Tu usuario todavía no tiene un rol asignado. Elegí con cuál entrás hoy; un administrador
          lo va a dejar fijo desde el panel Usuarios. Si sos comercial, pedí que te asignen el rol.
        </p>
        <div className="axon-stack" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', justifyContent: 'center' }}>
          {opciones.map(rol => (
            <button
              key={rol}
              onClick={() => onRoleSelect(rol)}
              style={buttonBase}
            >
              Soy {ROLE_LABELS[rol]}
            </button>
          ))}
        </div>
        {onSignOut && (
          <button
            type="button"
            onClick={onSignOut}
            style={{ marginTop: '1.5rem', background: 'none', border: 'none', color: styles.colors.secondary, textDecoration: 'underline', cursor: 'pointer', fontSize: '0.875rem' }}
          >
            Cerrar sesión
          </button>
        )}
      </div>
    </div>
  );
};

export default RoleSelectionModal;
